// PrivateRoute.tsx
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';
import LoadingSpinner from '../common/LoadingSpinner';

interface PrivateRouteProps {
  redirectPath: string;
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({ redirectPath }) => {
  const { loggedIn, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner text='Cargando tus datos...'/>; // or a spinner component
  }

  return loggedIn ? <Outlet /> : <Navigate to={redirectPath} />;
};


export const PublicRoute: React.FC = () => {
  return <Outlet />;
};


